import type { LiveCheckinRewardType, LiveCheckinTaskType } from '../types/check-in'

const TASK_FALLBACK: Record<LiveCheckinTaskType, { name: string; emoji: string }> = {
  check_in:        { name: 'Fazer check-in',       emoji: '📅' },
  do_live:         { name: 'Realizar lives',       emoji: '🎙️' },
  duration_live:   { name: 'Tempo em live',        emoji: '⏱️' },
  receive_point:   { name: 'Receber pontos',       emoji: '💎' },
  invite_user:     { name: 'Convidar usuários',    emoji: '✉️' },
  new_follower:    { name: 'Novos seguidores',     emoji: '⭐' },
  win_battle:      { name: 'Vencer batalhas',      emoji: '🥊' },
  play_gold_miner: { name: 'Jogar Gold Miner',     emoji: '⛏️' },
  play_rocket:     { name: 'Jogar Foguete',        emoji: '🚀' },
  play_slot:       { name: 'Jogar Slot',           emoji: '🎰' },
  play_spin_wheel: { name: 'Jogar Roleta',         emoji: '🎡' },
  play_luck_box:   { name: 'Jogar Caixa da Sorte', emoji: '🎁' },
}

export const taskFallback = (type: LiveCheckinTaskType) =>
  TASK_FALLBACK[type] ?? { name: type, emoji: '✨' }

const REWARD_LABEL: Record<LiveCheckinRewardType, string> = {
  app_coin:                'Moedas',
  frame_avatar:            'Frame de avatar',
  frame_card_profile:      'Frame de perfil',
  entrance_car:            'Carro de entrada',
  entrance_bubble:         'Bolha de entrada',
  background_room:         'Fundo de sala',
  frame_animation_profile: 'Animação de perfil',
  chat_bubble:             'Bolha de chat',
}

export const rewardTypeLabel = (type: LiveCheckinRewardType): string =>
  REWARD_LABEL[type] ?? type
